/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

export default ConditionalWrapper;
